// #region Global Imports
import styled from "styled-components";
// #endregion Global Imports

export type ImgContainerProps = {
  background?: string;
};
export const ImgContainer = styled.div<ImgContainerProps>(
  ({ background }) => `
    background: ${background};
    height: 200px;   
    background-size: cover;
    background-position: center center;
    border: 5px solid #FD3E60;
    border-radius: 15px;
    @media (max-width: 1399px) {
      width: 100%;
      height: 192px;
    } 
    @media (max-width: 992px) {
      width: 100%;
      height: 240px;

    }
  `
);

export const SliderImgCon = styled.div`
  position: relative;
  padding-top: 30px;
  @media (max-width: 992px) {
    padding-top: 25px;
  }
`;

export const SliderImgLogo = styled.img`
  border-radius: 25px;
  @media (max-width: 992px) {
  }
`;

export type LogoContainerProps = {
  background?: string;
};
export const LogoContainer = styled.div<LogoContainerProps>(
  ({ background }) => `
  width: 70.22px;
  background: ${background};
  height: 34.29px;
  background: #092040;
  border-radius: 50px;
  @media (max-width: 992px) {a
    width: 100%;
  }
  `
);

export type SubtextProps = {
  fontSize?: string;
  textAlign?: string;
  lineHeight?: string;
  fontWeight?: string;
  arabic?: boolean;
};
export const Subtext = styled.div<SubtextProps>(
  ({ fontSize, textAlign, lineHeight, fontWeight, arabic }) => `
      font-family: Dm Sans;
      font-style: normal;
      font-weight: ${fontWeight};
      font-size: ${fontSize};
      line-height: ${lineHeight ? lineHeight : "30px"};
      text-align: center;
      color: #333333;
      direction: ltr;
      @media (max-width: 992px) {
    
    }
`
);
